module.exports = "https://bin.bnbstatic.com/_next/static/images/mobile2x-2e6d1c98c80c84a880c13dadc1b9ace2.png";